<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap {
  width: 100%;
  height: 180px;
  padding: 5px 0;
  overflow: hidden;
  color: #fff;
  .swiper-wrap{
    height:256px;
  }
  .progress {
    width: 240px;
    height:10px;
    background:#fff;
  }
  .active-item {
    width: 100%;
    height: 22px;
    margin: 10px 0;
    display: flex;
    line-height: 32px;
    color: #fff
    align-items :center
  }
  .active-item  .progress {
    width: 240px;
    height:10px;
    margin-right: 20px;
    background: linear-gradient(to right, #ff9e2c,#ff4e00); /* 标准的语法 */
  }
  .active-item .cur {
    background: linear-gradient(to right, #fcc94a,#ff8700); /* 标准的语法 */
  }
  .active-item .cur1 {
    background: linear-gradient(to right, #c0e450,#75cd2d); /* 标准的语法 */
  }
  .active-item .cur2 {
    background: linear-gradient(to right, #5eb5ff,#217dfb); /* 标准的语法 */
  }
  .active-item i, .active-item .item-name-num, .active-item span, .active-item em {
    float: left;
    height: 100%;
    color: #fff;
    font-size: 20px;
    font-style: normal;
    box-sizing: border-box;
  }

  .active-item .item-rank {
    width: 35px;
    color: #fff;
    text-align: center;
  }

  .active-item .item-name-num {
    width: 400px;
    border-bottom: 1px solid rgba(0, 108, 243, 0.65);
  }

  .active-item .item-name-num .item-name {
    padding-left: 30px;
    border-right: 1px solid rgba(0, 108, 243, 0.65);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background: linear-gradient(to right, #040B58, #0A30B1);
  }

  .active-item .item-name-num .item-num {
    float: right;
    font-size: 16px;
  }
}
</style>

<template>
  <boxWrap :name="name">
    <div class="bar-wrap">
      <div class="active-item" v-for="(item,index) in listData" :key="item.id">
        <div style="width:100px">{{item.name}}</div>
        <div class="progress" :class="cla(index)" :style="width(item)"></div>
        <div>{{item.val}}</div>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
import '../../../../static/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      name: '扶贫情况',
      listData: [
        { name: '贫困户总数', val: '186183' },
        { name: '产业扶贫金额', val: '65286万' },
        { name: '未脱贫户数', val: '21168' },
        { name: '电商扶贫金额', val: '24777万' },
        { name: '已脱贫户数', val: '165015' }
      ],
      colorList: ['#f1641e', '#f1c21e', '#69ba32', '#0092ee'],
      lengthList: [300, 285, 155, 150],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 170,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide
  },
  computed: {
  },
  methods: {
    width () {

    },
    cla (index) {
      if (index === 1) {
        return 'cur'
      }
      if (index === 2) {
        return 'cur1'
      }
      if (index === 3) {
        return 'cur2'
      }
    },
    changeColor(index) {
      if (index <= 3) {
        return `background:${this.colorList[index]}`
      } else {
        return `background:${this.colorList[3]}`
      }
    },
    changeLength (index) {
      return `width:${this.lengthList[index]}px`
    }
  },
  mounted() {
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?8dc1af4e